module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 108);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/react-icons/Check"
var Check_ = __webpack_require__(35);
var Check_default = /*#__PURE__*/__webpack_require__.n(Check_);

// EXTERNAL MODULE: external "@splunk/react-icons/Error"
var Error_ = __webpack_require__(67);
var Error_default = /*#__PURE__*/__webpack_require__.n(Error_);

// EXTERNAL MODULE: external "@splunk/react-icons/Flag"
var Flag_ = __webpack_require__(68);
var Flag_default = /*#__PURE__*/__webpack_require__.n(Flag_);

// EXTERNAL MODULE: external "@splunk/react-icons/InfoCircle"
var InfoCircle_ = __webpack_require__(69);
var InfoCircle_default = /*#__PURE__*/__webpack_require__.n(InfoCircle_);

// EXTERNAL MODULE: external "@splunk/react-icons/Remove"
var Remove_ = __webpack_require__(29);
var Remove_default = /*#__PURE__*/__webpack_require__.n(Remove_);

// EXTERNAL MODULE: external "@splunk/react-icons/Success"
var Success_ = __webpack_require__(70);
var Success_default = /*#__PURE__*/__webpack_require__.n(Success_);

// EXTERNAL MODULE: external "@splunk/react-icons/Warning"
var Warning_ = __webpack_require__(71);
var Warning_default = /*#__PURE__*/__webpack_require__.n(Warning_);

// EXTERNAL MODULE: external "@splunk/react-ui/themes"
var themes_ = __webpack_require__(0);

// EXTERNAL MODULE: external "@splunk/react-ui/Link"
var Link_ = __webpack_require__(28);
var Link_default = /*#__PURE__*/__webpack_require__.n(Link_);

// CONCATENATED MODULE: ./src/Message/LinkStyles.ts



var StyledLink = external_styled_components_default()(Link_default.a).withConfig({
  displayName: "LinkStyles__StyledLink",
  componentId: "w06zjv-0"
})(["margin:0 3px;text-decoration:underline;color:inherit;&:not([disabled]){cursor:pointer;&:focus{box-shadow:", ";text-decoration:underline;&:active{box-shadow:none;text-decoration:underline;}}}"], Object(themes_["variable"])('Message', 'Link', 'focusShadow'));

// CONCATENATED MODULE: ./src/Message/Link.tsx
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var propTypes = {
  /** @private */
  children: external_prop_types_default.a.node,

  /**
   * Invoked with the DOM element when the component mounts and null when it unmounts.
   */
  elementRef: external_prop_types_default.a.func,

  /**
   * To open the link in a new window, set `openInNewContext` to `true`. An icon is added
   * indicating the behavior.
   */
  openInNewContext: external_prop_types_default.a.bool,

  /* The URL or path to link to. */
  to: external_prop_types_default.a.string
};
/**
 * A `Link` styled to work with `Message`'s `banner` appearance.
 */

function Link(props) {
  var children = props.children,
      otherProps = _objectWithoutProperties(props, ["children"]);

  return external_react_default.a.createElement(StyledLink, otherProps, children);
}

Link.propTypes = propTypes;
/* harmony default export */ var Message_Link = (Link);
// EXTERNAL MODULE: external "@splunk/react-ui/Box"
var Box_ = __webpack_require__(9);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box_);

// EXTERNAL MODULE: external "@splunk/react-ui/Clickable"
var Clickable_ = __webpack_require__(11);
var Clickable_default = /*#__PURE__*/__webpack_require__.n(Clickable_);

// CONCATENATED MODULE: ./src/Message/MessageStyles.ts




var MessageStyles_StyledIcon = external_styled_components_default.a.span.withConfig({
  displayName: "MessageStyles__StyledIcon",
  componentId: "eg66af-0"
})(["position:absolute;top:", ";left:0;width:", ";height:calc(100% - 8px);text-align:center;color:", ";padding-top:", ";"], Object(themes_["variable"])('Message', 'iconTop'), Object(themes_["variable"])('Message', 'iconWidth'), Object(themes_["variable"])('Message', 'iconColor'), Object(themes_["variable"])('Message', 'iconPaddingTop'));
var StyledContent = external_styled_components_default.a.span.withConfig({
  displayName: "MessageStyles__StyledContent",
  componentId: "eg66af-1"
})(["", ";color:", ";"], Object(themes_["mixin"])('reset')('inline'), function (_ref) {
  var fillStyle = _ref.fillStyle;
  return fillStyle ? Object(themes_["variable"])('Message', 'contentFillColor') : Object(themes_["variable"])('Message', 'contentColor');
});
var StyledRemove = external_styled_components_default()(Clickable_default.a).withConfig({
  displayName: "MessageStyles__StyledRemove",
  componentId: "eg66af-2"
})(["", ";border:1px solid transparent;border-radius:", ";color:", ";cursor:pointer;top:", ";right:", ";padding:", ";position:absolute;&:hover,&:focus{background:", ";border:", ";color:", ";}&:active{background:", ";box-shadow:", ";}"], Object(themes_["mixin"])('reset')('flex'), Object(themes_["variable"])('Message', 'removeIconBorderRadius'), Object(themes_["variable"])('Message', 'removeIconColor'), Object(themes_["variable"])('Message', 'removeIconTop'), Object(themes_["variable"])('Message', 'removeIconRight'), Object(themes_["variable"])('Message', 'removeIconPadding'), Object(themes_["variable"])('Message', 'removeIconHoverBackground'), Object(themes_["variable"])('Message', 'removeIconHoverBorder'), Object(themes_["variable"])('Message', 'removeIconHoverColor'), Object(themes_["variable"])('Message', 'removeIconActiveBackground'), Object(themes_["variable"])('Message', 'removeIconActiveBoxshadow'));
var StyledIconInfo = external_styled_components_default()(MessageStyles_StyledIcon).withConfig({
  displayName: "MessageStyles__StyledIconInfo",
  componentId: "eg66af-3"
})(["color:", ";", ";"], Object(themes_["variable"])('Message', 'iconInfoColor'), function (_ref2) {
  var fillStyle = _ref2.fillStyle;
  return fillStyle && Object(external_styled_components_["css"])(["background-color:", ";"], Object(themes_["variable"])('Message', 'iconInfoBackgroundColor'));
});
var StyledIconSuccess = external_styled_components_default()(MessageStyles_StyledIcon).withConfig({
  displayName: "MessageStyles__StyledIconSuccess",
  componentId: "eg66af-4"
})(["color:", ";", ";"], Object(themes_["variable"])('Message', 'iconSuccessColor'), function (_ref3) {
  var fillStyle = _ref3.fillStyle;
  return fillStyle && Object(external_styled_components_["css"])(["background-color:", ";"], Object(themes_["variable"])('Message', 'iconSuccessBackgroundColor'));
});
var StyledIconWarning = external_styled_components_default()(MessageStyles_StyledIcon).withConfig({
  displayName: "MessageStyles__StyledIconWarning",
  componentId: "eg66af-5"
})(["color:", ";", ";"], Object(themes_["variable"])('Message', 'iconWarningColor'), function (_ref4) {
  var fillStyle = _ref4.fillStyle;
  return fillStyle && Object(external_styled_components_["css"])(["background-color:", ";"], Object(themes_["variable"])('Message', 'iconWarningBackgroundColor'));
});
var StyledIconError = external_styled_components_default()(MessageStyles_StyledIcon).withConfig({
  displayName: "MessageStyles__StyledIconError",
  componentId: "eg66af-6"
})(["color:", ";", ";"], Object(themes_["variable"])('Message', 'iconErrorColor'), function (_ref5) {
  var fillStyle = _ref5.fillStyle;
  return fillStyle && Object(external_styled_components_["css"])(["background-color:", ";"], Object(themes_["variable"])('Message', 'iconErrorBackgroundColor'));
});
var iconReferences = [StyledIconInfo, StyledIconSuccess, StyledIconWarning, StyledIconError];

var MessageStyles_iconSpacing = function iconSpacing(iconReference) {
  return Object(external_styled_components_["css"])(["&[data-fill] > ", "{left:", ";}"],
  /* sc-sel */
  iconReference, Object(themes_["variable"])('spacingQuarter'));
};

var StyledBox = external_styled_components_default()(Box_default.a).withConfig({
  displayName: "MessageStyles__StyledBox",
  componentId: "eg66af-7"
})(["", ";position:relative;margin-bottom:", ";word-wrap:break-word;border-radius:", ";", " ", " ", " &[data-fill='info']{", ";}&[data-fill='success']{", ";}&[data-fill='warning']{", ";}&[data-fill='error']{", ";}", ";"], Object(themes_["mixin"])('reset')('block'), Object(themes_["variable"])('spacingHalf'), function (props) {
  return props.appearance !== 'banner' && Object(themes_["variable"])('Message', 'boxBorderRadius');
}, function (_ref6) {
  var appearance = _ref6.appearance;
  return appearance === 'banner' && Object(external_styled_components_["css"])(["text-align:center;"]);
}, function (_ref7) {
  var fillStyle = _ref7.fillStyle;
  return fillStyle && Object(external_styled_components_["css"])(["& > ", "{color:", ";}"],
  /* sc-sel */
  MessageStyles_StyledIcon, Object(themes_["variable"])('Message', 'iconFillColor'));
}, function (_ref8) {
  var hasRemoveIcon = _ref8.hasRemoveIcon;
  return hasRemoveIcon ? Object(external_styled_components_["css"])(["padding:", ";"], Object(themes_["variable"])('Message', 'boxPaddingWithRemoveIcon')) : Object(external_styled_components_["css"])(["padding:", ";"], Object(themes_["variable"])('Message', 'boxPadding'));
}, function (_ref9) {
  var appearance = _ref9.appearance;
  return appearance === 'banner' ? Object(external_styled_components_["css"])(["background-color:", ";& > ", "{color:", ";}"], Object(themes_["variable"])('Message', 'bannerInfoBackgroundColor'),
  /* sc-sel */
  StyledContent, Object(themes_["variable"])('Message', 'bannerTextColorDark')) : Object(external_styled_components_["css"])(["background-color:", ";border:1px solid ", ";"], Object(themes_["variable"])('Message', 'boxInfoBackgroundColor'), Object(themes_["variable"])('Message', 'boxInfoBorderColor'));
}, function (_ref10) {
  var appearance = _ref10.appearance;
  return appearance === 'banner' ? Object(external_styled_components_["css"])(["background-color:", ";& > ", "{color:", ";}"], Object(themes_["variable"])('Message', 'bannerSuccessBackgroundColor'),
  /* sc-sel */
  StyledContent, Object(themes_["variable"])('Message', 'bannerTextColorDark')) : Object(external_styled_components_["css"])(["background-color:", ";border:1px solid ", ";"], Object(themes_["variable"])('Message', 'boxSuccessBackgroundColor'), Object(themes_["variable"])('Message', 'boxSuccessBorderColor'));
}, function (_ref11) {
  var appearance = _ref11.appearance;
  return appearance === 'banner' ? Object(external_styled_components_["css"])(["background-color:", ";& > ", "{color:", ";}"], Object(themes_["variable"])('Message', 'bannerWarningBackgroundColor'),
  /* sc-sel */
  StyledContent, Object(themes_["variable"])('Message', 'bannerTextColorLight')) : Object(external_styled_components_["css"])(["background-color:", ";border:1px solid ", ";"], Object(themes_["variable"])('Message', 'boxWarningBackgroundColor'), Object(themes_["variable"])('Message', 'boxWarningBorderColor'));
}, function (_ref12) {
  var appearance = _ref12.appearance;
  return appearance === 'banner' ? Object(external_styled_components_["css"])(["background-color:", ";& > ", "{color:", ";}"], Object(themes_["variable"])('Message', 'bannerErrorBackgroundColor'),
  /* sc-sel */
  StyledContent, Object(themes_["variable"])('Message', 'bannerTextColorLight')) : Object(external_styled_components_["css"])(["background-color:", ";border:1px solid ", ";"], Object(themes_["variable"])('Message', 'boxErrorBackgroundColor'), Object(themes_["variable"])('Message', 'boxErrorBorderColor'));
}, function (props) {
  return !Object(themes_["variable"])('Message', 'smallIcon')(props) && iconReferences.map(function (iconReference) {
    return MessageStyles_iconSpacing(iconReference);
  });
});

// CONCATENATED MODULE: ./src/Message/Message.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Message_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Message_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Message_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }














var Message_propTypes = {
  /**
   * Changes the style of the Message.
   */
  appearance: external_prop_types_default.a.oneOf(['default', 'fill', 'banner']),

  /** @private */
  children: external_prop_types_default.a.node,

  /**
   * Invoked with the DOM element when the component mounts and null when it unmounts.
   */
  elementRef: external_prop_types_default.a.func,

  /**
   * Adds a background and border. This prop will be removed in the next major version
   * of this library. Use the `appearance` prop instead.
   */
  fill: external_prop_types_default.a.bool,

  /** @private */
  theme: external_prop_types_default.a.object,

  /**
   * Includes a remove button if set. Always set this prop when using the `banner`
   * appearance, never set it when using the `default` appearance.
   */
  onRequestRemove: external_prop_types_default.a.func,

  /** Sets the severity or type of this `Message`. */
  type: external_prop_types_default.a.oneOf(['info', 'success', 'warning', 'error'])
};
var defaultProps = {
  appearance: 'default',
  fill: false,
  type: 'warning',
  theme: null
};

function Message(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children,
      type = _ref.type,
      fill = _ref.fill,
      theme = _ref.theme,
      onRequestRemove = _ref.onRequestRemove,
      otherProps = Message_objectWithoutProperties(_ref, ["appearance", "children", "type", "fill", "theme", "onRequestRemove"]);

  var smallIcon = Object(themes_["variable"])('Message', 'smallIcon')({
    theme: theme
  });
  var Icon = {
    info: smallIcon ? Flag_default.a : InfoCircle_default.a,
    success: smallIcon ? Check_default.a : Success_default.a,
    warning: Warning_default.a,
    error: Error_default.a
  }[type];
  var StyledIcon = {
    info: StyledIconInfo,
    success: StyledIconSuccess,
    warning: StyledIconWarning,
    error: StyledIconError
  }[type];
  var iconSize = smallIcon ? '16px' : '24px';
  var removeSize = smallIcon ? '14px' : '12px';
  var fillStyle = fill || appearance === 'fill' || appearance === 'banner';

  function handleRemoveClick(e) {
    onRequestRemove(e);
  }

  return external_react_default.a.createElement(StyledBox, _extends({
    appearance: appearance,
    "data-test": "message",
    "data-fill": fillStyle ? type : undefined,
    "data-test-type": type,
    fillStyle: fillStyle,
    hasRemoveIcon: onRequestRemove
  }, otherProps), (appearance === 'default' || appearance === 'fill') && external_react_default.a.createElement(StyledIcon, {
    fillStyle: fillStyle
  }, external_react_default.a.createElement(Icon, {
    width: iconSize,
    height: iconSize
  })), external_react_default.a.createElement(StyledContent, {
    "data-test": "content",
    fillStyle: fillStyle
  }, children), onRequestRemove && external_react_default.a.createElement(StyledRemove, {
    "data-test": "remove",
    onClick: handleRemoveClick
  }, external_react_default.a.createElement(Remove_default.a, {
    width: removeSize,
    height: removeSize
  })));
}

Message.propTypes = Message_propTypes;
Message.defaultProps = defaultProps;
Message.Link = Message_Link;
/* harmony default export */ var Message_Message = (Object(external_styled_components_["withTheme"])(Message));

// CONCATENATED MODULE: ./src/Message/index.ts
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return Message_Message; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Link", function() { return Message_Link; });



/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Clickable");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Link");

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Remove");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Check");

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Error");

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Flag");

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/InfoCircle");

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Success");

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Warning");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Box");

/***/ })

/******/ });